const ES = {
    title: 'Dispositivos',
    table: {
        title: 'Dispositivos',
        columns: {
            id: 'Id del Dispositivo',
            browser: 'Navegador',
            vendor: 'Proveedor',
            model: 'Modelo',
            os: 'Sistema operativo',
            date: 'Fecha',
            status: 'Estado',
            actions: 'Acciones',
        },
        status: {
            0: 'Activo',
            1: 'Inactivo',
            title: 'Estado'
        },
    }
};

export default ES;
